import { useEffect, useState } from "react";
import { api, eur, deDate } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Link } from "react-router-dom";
import { Printer } from "lucide-react";

export default function Vertraege() {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/contracts").then((r) => setContracts(r.data)).finally(() => setLoading(false));
  }, []);

  const printPdf = async (id) => {
    const { data } = await api.get(`/contracts/${id}/pdf`, { responseType: "blob" });
    window.open(URL.createObjectURL(new Blob([data], { type: "application/pdf" })), "_blank");
  };

  return (
    <div className="space-y-6" data-testid="vertraege-page">
      <div>
        <div className="text-xs font-mono uppercase tracking-wider text-zinc-400">L19</div>
        <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight mt-1">Verträge</h1>
        <p className="text-sm text-zinc-500 mt-1">Alle Kaufverträge mit Signaturstatus. Unterschreiben erfolgt im jeweiligen Ankauf.</p>
      </div>
      <div className="bg-white border border-zinc-200 rounded-xl shadow-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead><tr className="border-b border-zinc-100 text-left">
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-400">Vertrag</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-400">Ankauf</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-400">Verkäufer</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-400">Datum</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-400">Status</th>
            <th className="px-5 py-3 text-[10px] font-mono uppercase tracking-wider text-zinc-400 text-right">Betrag</th>
            <th className="px-5 py-3"></th>
          </tr></thead>
          <tbody className="divide-y divide-zinc-50">
            {loading && <tr><td colSpan={7} className="px-5 py-8 text-center text-zinc-400 font-mono text-xs">Laden…</td></tr>}
            {!loading && contracts.length === 0 && <tr><td colSpan={7} className="px-5 py-8 text-center text-zinc-400">Noch keine Verträge.</td></tr>}
            {contracts.map((c) => (
              <tr key={c.id} className="hover:bg-zinc-50" data-testid={`contract-row-${c.number}`}>
                <td className="px-5 py-3 font-mono text-xs">{c.number}</td>
                <td className="px-5 py-3 font-mono text-xs text-zinc-500">{c.purchase_number || "–"}</td>
                <td className="px-5 py-3">{c.seller_name || "–"}</td>
                <td className="px-5 py-3 text-zinc-500">{deDate(c.date)}</td>
                <td className="px-5 py-3">
                  <span className={`text-[10px] font-mono px-2 py-0.5 rounded-full border ${c.status === "unterschrieben" ? "bg-emerald-50 text-emerald-800 border-emerald-200" : "bg-zinc-100 text-zinc-700 border-zinc-300"}`} data-testid={`contract-status-${c.number}`}>
                    {c.status === "unterschrieben" ? "Unterschrieben" : "Entwurf"}
                  </span>
                </td>
                <td className="px-5 py-3 text-right font-medium">{eur(c.total)}</td>
                <td className="px-5 py-3 text-right">
                  <Button variant="outline" size="sm" onClick={() => printPdf(c.id)} data-testid={`contract-pdf-${c.number}`} className="min-h-[44px]"><Printer className="w-3.5 h-3.5 mr-1" /> PDF</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-zinc-400">Offene Verträge unterschreiben: <Link to="/app/ankauf" className="underline hover:text-zinc-900">zur Ankaufshistorie</Link></p>
    </div>
  );
}
